
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Chronic_tension_type_headaches",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Chronic_tension_type_headaches.vue